import React from 'react';
import classNames from 'classnames';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MiniCallout } from '../utils/mini-callout';
import { miniCalloutStyle } from '../utils/mini-callout-styles';
import { TargetComponent } from '../types';

interface IMiniCalloutProps {
  message: string,
  notificationId: string,
  i18n: any,
  classes: any,
  linkTarget?: string;
}

class unstyleMiniCallout extends React.PureComponent<IMiniCalloutProps> {
  logger: any;
  bindedHandleClick: any;
  logHandlers: Map<Element, () => void>;
  innerTexts: string[];
  titleText: string;
  isPureAlink: boolean;

  constructor(props) {
    super(props);
    this.logger = props?.instrumentation?.notificationTopBanner?.create?.()?.actionLink?.create?.();
    this.bindedHandleClick = this.handleClick.bind(this);
    this.logHandlers = new Map();
    this.innerTexts = [];
    this.titleText = '';
    this.isPureAlink = false;
  }

  removeClickEvents(renderedEls: HTMLElement[] = []) {
    const elsToRemove = new Map(this.logHandlers);
    renderedEls.forEach((el) => { elsToRemove.delete(el); });
    elsToRemove.forEach((handler, el) => {
      el.removeEventListener('click', handler, true);
      this.logHandlers.delete(el);
    });
  }

  bindClickEvent() {
    if (this.isPureAlink) {
      const className = 'notification-center-top-banner-action';
      const element = document.getElementsByClassName(className);
      if (element[0]) {
        const AElements = Array.prototype.slice.call(element[0].getElementsByTagName('a'));
        this.removeClickEvents(AElements);
        AElements.forEach((AElement, i) => {
          if (!this.logHandlers.has(AElement)) {
            const handler = () => this.bindedHandleClick(i);
            AElement.addEventListener('click', handler, true);
            this.logHandlers.set(AElement, handler);
            this.innerTexts[i] = AElement.innerText;
          }
        });
        this.log(`binded, titleText=${this.titleText}, innerText=[${this.innerTexts}], notificationId=${this.props.notificationId}`);
      }
    }
  }

  componentDidMount() {
    this.bindClickEvent();
    this.log(`showed, titleText=${this.titleText}, innerText=[${this.innerTexts}], notificationId=${this.props.notificationId}`);
  }

  componentDidUpdate() {
    this.bindClickEvent();
  }

  log(message) {
    this.logger?.trace(message);
  }

  handleClick(index = 0) {
    this.log(`clicked, titleText=${this.titleText}, innerText=${this.innerTexts[index]}, notificationId=${this.props.notificationId}`);
  }

  componentWillUnmount() {
    if (this.isPureAlink) {
      this.removeClickEvents();
    }
  }

  render() {
    const { classes, i18n, linkTarget } = this.props;
    const doc = (new DOMParser()).parseFromString(this.props.message, 'text/html');
    const aElements = doc.body.getElementsByTagName('a');
    const openInNewWindow = aElements.length !== 0 && aElements[0].getElementsByClassName('iconba-OpenInNewWindow').length !== 0;
    if (aElements.length <= 0) {
      this.titleText = doc.body.innerText;
      return (<span className={classNames('notification-center-top-banner-message', classes.content)} title={doc.body.innerText} dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }} />)
    } else if (!openInNewWindow) {
      const aTags = Array.prototype.slice.call(aElements).map((el: HTMLLinkElement) => {
        const aTag = doc.body.removeChild(el);
        aTag.classList.add(classes.button);
        if (!aTag.style.color) {
          aTag.style.color = 'black';
        }

        if (linkTarget) {
          aTag.setAttribute('target', linkTarget);
        }
        return aTag.outerHTML;
      }).join('');
      this.titleText = doc.body.innerHTML;
      this.isPureAlink = true;
      return (
        <React.Fragment>
        <span className={classNames('notification-center-top-banner-message', classes.content)}>{doc.body.innerHTML}</span>
        <span className={classNames('notification-center-top-banner-action', classes.calloutTargetContainer)} dangerouslySetInnerHTML={{ __html: aTags }} />
        </React.Fragment>
      )
    }

    const aElement = doc.body.getElementsByTagName('a')[0];
    const { innerText } = aElement;
    const { href } = aElement;

    while (doc.body.getElementsByTagName('a').length > 0) { doc.body.removeChild(doc.body.getElementsByTagName('a')[0]); }

    this.titleText = doc.body.innerHTML;
    this.innerTexts = [innerText];
    return (
        <React.Fragment>
          <span className={classNames('notification-center-top-banner-message', classes.content)} title={doc.body.innerHTML} dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }} />
          <MiniCallout
            classes={classes}
            innerText={innerText}
            href={href}
            i18n={i18n}
            bannerType={TargetComponent.TopBanner}
            handleClick={this.bindedHandleClick}
          />
        </React.Fragment>
    )
  }
}

export const MiniCalloutWrapper = withInstrumentation(withDefaultStyles(unstyleMiniCallout, miniCalloutStyle));
